/*eslint-disable*/
import api from '../'

class SynonymsApi {
    // get: /synonyms
    static getSynonymsByParams (params) {
        return api.axios.get('/synonyms', { params })
            .then(response => response.data);
    }
}

export default SynonymsApi;
